export default {
  isLoggedIn: ({ item }) => {
    return item.token !== null;
  },
  fullName: ({ item }) => {
    return `${item.first_name} ${item.last_name}`;
  },
};
